import consts from "../consts";
import utils from "../utils";
import { Container, Sprite, Texture } from "pixi.js";

import gsap from "gsap";
import gsapPixiPlugin from "gsap/PixiPlugin";

gsapPixiPlugin.registerPIXI(window.PIXI);
gsap.registerPlugin(gsapPixiPlugin);

const SCENE_NAME = "PRELOAD";

export default class Preload extends Container {
  constructor() {
    super();
    this.name = SCENE_NAME;
    this.loadedAssetsCount = 0;
    this.onLoggedInCallback = () => {};
    console.log("[PRELOAD] constructor");
    this.initialize();
  }

  initialize() {
    console.log("[PRELOAD] initialize");
    this.x = consts.game.width / 2;
    this.y = consts.game.height / 2;
    this.drawLoadingScreen();
  }

  drawLoadingScreen() {
    console.log("[PRELOAD] drawLoadingScreen");
    const loadingContainer = new Container();
    loadingContainer.name = "LOADING_CONTAINER";
    loadingContainer.x = 0;
    loadingContainer.y = 0;

    const logo = new Sprite(Texture.from(utils.assetUrl("logo.png")));
    logo.name = "LOGO";
    logo.y -= utils.isMobile ? consts.game.height * 0.1 : 70;
    logo.anchor.set(0.5);
    const logoRatio =
      Math.min(consts.game.width / 1010, consts.game.height / 914) -
      (utils.isMobile ? 0.05 : 0.37);
    logo.scale.set(logoRatio, logoRatio);

    loadingContainer.addChild(logo);
    this.addChild(loadingContainer);

    this.drawLoadingBar();
  }

  async drawLoadingBar() {
    console.log("[PRELOAD] drawLoadingBar start");
    const loadingBar = new Container();
    loadingBar.visible = false;
    loadingBar.name = "LOADING_BAR";
    loadingBar.x = 0;
    loadingBar.y = !utils.isMobile
      ? consts.game.height / 2 - 96
      : consts.game.height - consts.game.height * 0.25 * 2.5;

    const loadingBarRatio = Math.min(
      consts.game.width / 1309,
      consts.game.height / 96
    );

    if (utils.isMobile) {
      loadingBar.scale.set(loadingBarRatio - 0.05, loadingBarRatio - 0.05);
    } else {
      loadingBar.scale.set(loadingBarRatio - 0.3, loadingBarRatio - 0.3);
    }

    const loadingBarBg = new Sprite(
      Texture.from(utils.assetUrl("loading-bar-bg.png"))
    );
    loadingBarBg.x = 0;
    loadingBarBg.y -= 5;
    loadingBarBg.anchor.set(0.5);

    loadingBar.addChild(loadingBarBg);

    const loadingBarFrame = new Sprite(
      Texture.from(utils.assetUrl("loading-bar-frame.png"))
    );
    loadingBarFrame.x = 0;
    loadingBarFrame.y = 0;
    loadingBarFrame.anchor.set(0.5);

    const loadingBarFill = new Sprite(
      Texture.from(utils.assetUrl("loading-bar-fill.png"))
    );
    loadingBarFill.name = "LOADING_BAR_FILL";
    loadingBarFill.width = 1310;
    loadingBarFill.height = 130;
    loadingBarFill.x = 0;
    loadingBarFill.y = 5;
    loadingBarFill.anchor.set(0.5);

    const loadingBarFillMask = new Sprite(Texture.WHITE);
    loadingBarFillMask.name = "LOADING_BAR_FILL_MASK";
    loadingBarFillMask.width = 150;
    loadingBarFillMask.height = 110;
    loadingBarFillMask.x -= loadingBarFill.width / 2;
    loadingBarFillMask.y -= 96;
    loadingBarFill.addChild(loadingBarFillMask);
    loadingBarFill.mask = loadingBarFillMask;

    loadingBar.addChild(loadingBarFill);
    loadingBar.addChild(loadingBarFrame);
    this.addChild(loadingBar);

    this.onResize(window.innerWidth, window.innerHeight);
    this.showLoadingBar();
    console.log("[PRELOAD] drawLoadingBar end");
  }

  showLoadingBar() {
    console.log("[PRELOAD] showLoadingBar");
    const bar = this.getChildByName("LOADING_BAR");
    if (!bar) {
      console.warn("[PRELOAD] showLoadingBar: LOADING_BAR not found!");
      return;
    }
    bar.visible = true;
  }

  async finish() {
    console.log("[PRELOAD] finish called");
    return new Promise((resolve) => {
      const loadingBarContainer = this.getChildByName("LOADING_BAR");
      if (!loadingBarContainer) {
        console.warn("[PRELOAD] finish: LOADING_BAR not found!");
        resolve(false);
        return;
      }
      const loadingBarFill =
        loadingBarContainer.getChildByName("LOADING_BAR_FILL");
      const loadingBarFillMask = loadingBarFill.getChildByName(
        "LOADING_BAR_FILL_MASK"
      );

      gsap.to(loadingBarFillMask, {
        duration: 1,
        width: 1309,
        ease: "ease",
        onComplete: () => {
          console.log("[PRELOAD] loading bar animation complete");
          gsap.to(this, {
            duration: 0.25,
            alpha: 0,
            ease: "linear",
            onComplete: () => {
              console.log("[PRELOAD] finished and resolved");
              resolve(true);
            },
          });
        },
      });
    });
  }

  async increaseLoadingBarProgress(assetsCount) {
    console.log("[PRELOAD] increaseLoadingBarProgress", {
      loadedAssetsCount: this.loadedAssetsCount + 1,
      totalAssets: assetsCount,
    });

    // ✅ Fazla çağrıyı engelle
    if (this.loadedAssetsCount >= assetsCount) {
      console.warn("[PRELOAD] progress called after limit reached!");
      return Promise.resolve(false);
    }

    return new Promise((resolve) => {
      const loadingBarContainer = this.getChildByName("LOADING_BAR");
      if (!loadingBarContainer) {
        console.warn(
          "[PRELOAD] increaseLoadingBarProgress: LOADING_BAR not found!"
        );
        resolve(false);
        return;
      }
      const loadingBarFill =
        loadingBarContainer.getChildByName("LOADING_BAR_FILL");
      const loadingBarFillMask = loadingBarFill.getChildByName(
        "LOADING_BAR_FILL_MASK"
      );

      this.loadedAssetsCount++;
      const WIDTH = 1309 / assetsCount;

      gsap.to(loadingBarFillMask, {
        duration: 1,
        pixi: {
          width: (loadingBarFillMask.width += WIDTH),
        },
        onComplete: () => {
          console.log("[PRELOAD] progress animation complete");
          resolve(true);
        },
      });
    });
  }

  onResize(width, height) {
    console.log("[PRELOAD] onResize", { width, height });
    this.x = width / 2;
    this.y = height / 2;

    const loadingContainer = this.getChildByName("LOADING_CONTAINER");
    if (loadingContainer) {
      const logo = loadingContainer.getChildByName("LOGO");
      if (logo) {
        logo.position.y = (utils.isMobile ? consts.game.height * 0.1 : 70) * -1;
        const logoRatio =
          Math.min(width / 1010, height / 914) - (utils.isMobile ? 0.05 : 0.37);
        logo.scale.set(logoRatio, logoRatio);
      }
    }

    const loadingBar = this.getChildByName("LOADING_BAR");
    if (loadingBar) {
      loadingBar.position.y = !utils.isMobile
        ? height / 2 - 96
        : height - height * 0.25 * 2.5;

      const loadingBarRatio = Math.min(width / 1309, height / 96);

      if (utils.isMobile) {
        loadingBar.scale.set(loadingBarRatio - 0.05, loadingBarRatio - 0.05);
      } else {
        loadingBar.scale.set(loadingBarRatio - 0.3, loadingBarRatio - 0.3);
      }
    }
  }
}
